var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[(_vm.isloadingSlots)?_c('spinner'):_vm._e(),_c('el-calendar',{attrs:{"first-day-of-week":7,"format":"yyyy/MM/dd","disabled":""},on:{"input":_vm.setSelectedDate},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{class:[_vm.isDayAvailable(data.day), data.isSelected ? 'is-selected' : '', 'slot-cell']},[_c('span',[_vm._v(_vm._s(_vm.getDay(data.day)))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }